/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_5Inputs */

const en_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center`)
};

const fr_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre`)
};

const de_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center`)
};

const it_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

const ru_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр`)
};

const es_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

const zh_cn2_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中心`)
};

const ja_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中心`)
};

const hi_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र`)
};

const pt_pt2_live_caption_youtube_region_5 = /** @type {(inputs: Live_Caption_Youtube_Region_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

/**
* | output |
* | --- |
* | "Center" |
*
* @param {Live_Caption_Youtube_Region_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_5 = /** @type {((inputs?: Live_Caption_Youtube_Region_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_5(inputs)
	if (locale === "de") return de_live_caption_youtube_region_5(inputs)
	if (locale === "it") return it_live_caption_youtube_region_5(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_5(inputs)
	if (locale === "es") return es_live_caption_youtube_region_5(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_5(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_5(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_5(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_5(inputs)
	return en_live_caption_youtube_region_5(inputs)
});